import { apiUrl, createApiClient, createAuthStore } from '@riskpay/ui-components';

/**
 * One auth store and one API client per portal, wired together.
 *
 * `getToken` reads through the store rather than capturing a value, so a token
 * refresh takes effect on the very next request without re-creating the client.
 */
export const useAuth = createAuthStore('riskpay.merchant.session');

export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL ?? apiUrl('/api/v1/merchant'),
  getToken: () => useAuth.getState().getToken(),
  onUnauthorized: () => useAuth.getState().signOut(),
  // Read fresh on every request so the Test/Live switch takes effect at once.
  getMode: () => useAuth.getState().session?.mode ?? 'TEST',
});

/** The unauthenticated endpoints live outside the /merchant prefix. */
export const authApi = createApiClient({
  baseUrl: import.meta.env.VITE_AUTH_URL ?? apiUrl('/api/v1/auth'),
  getToken: () => null,
  onUnauthorized: () => undefined,
});
